import VideoGallery from './video-gallery'

export default VideoGallery
